export enum ReferrerType {
  Partner = 'partner',
  User = 'user',
}

export enum DiscountType {
  fixed = 'fixed',
  percentage = 'percentage',
}

export interface DiscountTypeAndAmount {
  discountAmount: number;
  discountType: DiscountType;
}

// Taken from https://github.com/farmersdog/api/blob/73d3a37e27dbb5f1e4e5dea923b3f87474872aa6/src/models/coupon.ts
export enum CouponType {
  Affiliate = 'affiliate',
  Ambassador = 'ambassador',
  Breeder = 'breeder',
  Community = 'community',
  CommunityPartnership = 'community_partnership',
  Content = 'content',
  CustomerAmbassador = 'customer_ambassador',
  Direct = 'direct',
  DirectMail = 'direct_mail',
  Display = 'display',
  DogPro = 'dog_pro',
  Email = 'email',
  Employee = 'employee',
  Events = 'events',
  Gift = 'gift',
  Influencer = 'influencer',
  Internal = 'internal',
  Native = 'native',
  Newsletter = 'newsletter',
  Npo = 'npo',
  Partner = 'partner',
  Phone = 'phone',
  Podcast = 'podcast',
  Radio = 'radio',
  Referral = 'referral',
  Search = 'search',
  ServiceDog = 'service_dog',
  Shelter = 'shelter',
  Social = 'social',
  Veterinarian = 'veterinarian',
  Whitelisting = 'whitelisting',
  WorkingDog = 'working_dog',
}
